import { ListProps, Paging } from '@Core';
import { BaseHttpController } from '@Core/controller/BaseHttpController';
import { CameraSIM, CameraSIMPreview } from '@EcamModel/model/CameraSIM';
import { AxiosInstance } from 'axios';
import FormData from 'form-data';
import { ICameraSIMHttpController } from '../ICameraSIMHttpController';

export class CameraSIMHttpController extends BaseHttpController<CameraSIM> implements ICameraSIMHttpController {
    constructor(serviceUrl: string, client: AxiosInstance) {
        super(serviceUrl, 'camera-sim', client);
    }

    async list(props: ListProps<CameraSIM>): Promise<Paging<CameraSIM>> {
        return await this.doPost({ path: 'list', body: props }).then((res) => res.data);
    }

    async bulkCreate(props: { list: CameraSIM[] }): Promise<CameraSIM[]> {
        return await this.doPost({ path: 'bulk-create', body: props }).then((res) => res.data);
    }

    async previewSIM(file: Express.Multer.File): Promise<CameraSIMPreview[]> {
        return await this.doPost({
            path: 'preview',
            body: file,
            config: {
                headers: { 'Content-Type': 'multipart/form-data' },
            },
        }).then((res) => res.data);
    }
}
